import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { toast, MaterializeAction } from 'angular2-materialize';

import { CatalogsSettingsService, Folios, SpecialRoles } from '../../services/catalogs-settings.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { EmployeeService } from '../../services/employee.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { Globals } from '../../globals';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css', '../../app.component.css']
})

export class SettingsComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    foliosForm: FormGroup;
    defaultsForm: FormGroup;
    isoDescriptionsForm: FormGroup;

    tableQuantity = [
        {name: 'Cinco', value: 5},
        {name: 'Diez', value: 10},
        {name: 'Veinte', value: 20},
        {name: 'Cincuenta', value: 50}
    ];
    tableQuantityInit;

    payrollSettingsForm: FormGroup;
    payrollSettings: any = [];

    paymentPeriod = [{id$: 'weekly', name: 'Semanal'}, {id$: 'biweekly', name: 'Quincenal'}, {id$: 'monthly', name: 'Mensual'}];
    @Input() paymentPeriodInit: string;
    @Output() paymentPeriodModelChange = new EventEmitter();

    weekdays = [{id$: 'monday', name: 'Lunes', prev: 'sunday', prevName: 'Domingo'},
                {id$: 'tuesday', name: 'Martes', prev: 'monday', prevName: 'Lunes'},
                {id$: 'wednesday', name: 'Miércoles', prev: 'tuesday', prevName: 'Martes'},
                {id$: 'thursday', name: 'Jueves', prev: 'wednesday', prevName: 'Miércoles'},
                {id$: 'friday', name: 'Viernes', prev: 'thursday', prevName: 'Jueves'},
                {id$: 'saturday', name: 'Sábado', prev: 'friday', prevName: 'Viernes'},
                {id$: 'sunday', name: 'Domingo', prev: 'saturday', prevName: 'Sábado'}];
    @Input() weekdaysInit: string;
    @Output() weekdaysModelChange = new EventEmitter();

    finalDayText: string;

    activitiesCaptureVal: number;

    pickatimeParams = Utils.pickatimeParams();

    businessDayMondayVal = false;
    businessDayTuesdayVal = false;
    businessDayWednesdayVal = false;
    businessDayThursdayVal = false;
    businessDayFridayVal = false;
    businessDaySaturdayVal = false;
    businessDaySundayVal = false;

    gpsSubs: any;

    permissions = [];

    tab: number = 0;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private service: CatalogsSettingsService,
        private authService: AuthService,
        private permissionService: PermissionService,
        private employeeService: EmployeeService,
        private fsService: FirestoreService,
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        let employeeSub = employeeService.getEmployees().subscribe(employees => {
            employeeSub.unsubscribe();
            [this.rowsRead[0], this.employees] = employees.reduce((acc, cur) => [
                [{ ...cur, id: cur.id$, name: `${cur.name} ${cur.lastName}` }, ...acc[0]],
                {[cur.id$]: { ...cur, name: `${cur.name} ${cur.lastName}` }, ...acc[1]}
            ], [[], []]);
        })

        this.gpsSubs = this.service.getPayrollSettings('1').subscribe( ({folios, defaults, isoDescriptions={}, specialRoles=<SpecialRoles>{}, ...payrollObj}) => {
            this.gpsSubs.unsubscribe();

            this.payrollSettings = payrollObj;
            console.log(payrollObj);

            this.paymentPeriodInit = this.payrollSettings.paymentPeriod;
            this.weekdaysInit = this.payrollSettings.startDay;
            this.activitiesCaptureVal = this.payrollSettings.activitiesCapture;
            this.tableQuantityInit = this.payrollSettings.tableQuantity;

            this.businessDayMondayVal = this.payrollSettings.businessDays[1];
            this.businessDayTuesdayVal = this.payrollSettings.businessDays[2];
            this.businessDayWednesdayVal = this.payrollSettings.businessDays[3];
            this.businessDayThursdayVal = this.payrollSettings.businessDays[4];
            this.businessDayFridayVal = this.payrollSettings.businessDays[5];
            this.businessDaySaturdayVal = this.payrollSettings.businessDays[6];
            this.businessDaySundayVal = this.payrollSettings.businessDays[0];

            this.foliosForm.patchValue(folios);
            this.defaultsForm.patchValue(defaults);
            this.isoDescriptionsForm.patchValue(isoDescriptions);
            let {qualityInspector=''} = specialRoles;
            this.selectedIds = [qualityInspector];

            this.fsService.docWithId<Folios>(`${Globals.CATALOGS_SETTINGS}/folios`).then(({customerBill, income}) => { this.foliosForm.patchValue({customerBill, income}) });
        });
    }

    get allFormsValid(){
        return (
            (this.payrollSettingsForm.valid || !this.payrollSettingsForm.touched) &&
            (this.foliosForm.valid || !this.foliosForm.touched) &&
            (this.defaultsForm.valid || !this.defaultsForm.touched)
        );
    }
    ngOnInit() {
        this.payrollSettingsForm = this.formBuilder.group({
            paymentPeriod: ['', Validators.required],
            startDay: '',
            finalDay: '',
            activitiesCapture: '',
            tableQuantity: ['', Validators.required],
            multiplicationFactor: ['', Validators.required],
            paymentPerPerson: ['', Validators.required],
            paymentPerPersonF: ['', Validators.required],
            cfCommission: ['', Validators.required],
            maxDaysLoad: ['', [Validators.required, Validators.min(1), Validators.max(31)]],
            entryTime: ['', [Validators.required]],
            businessDayMonday: '',
            businessDayTuesday: '',
            businessDayWednesday: '',
            businessDayThursday: '',
            businessDayFriday: '',
            businessDaySaturday: '',
            businessDaySunday: '',
            bonus: [0, Validators.required],
        });
        this.foliosForm = this.formBuilder.group({
            purchaseOrder: ['', Validators.required],
            purchaseRequest: ['', Validators.required],
            customerBill: ['', Validators.required],
            billCreditNote: [0, Validators.required],
            income: ['', Validators.required],
            remission: ['', Validators.required],
            //suaje: ['', Validators.required],
            nextIn:['', Validators.required],
            nextOut: ['', Validators.required]
        });
        this.defaultsForm = this.formBuilder.group({
            iva: ['', Validators.required],
            utilityQuot: ['', Validators.required],
            fixedQuot: ['', Validators.required],
            commissionQuot: ['', Validators.required],
            mermaQuot: ['', Validators.required],
            isrRetention: ['', Validators.required],
            ivaRetention: ['', Validators.required]
        });
        this.isoDescriptionsForm = this.formBuilder.group({
            COT: '',
            OdP: '',
            Rem: '',
            CrtCal: '',
            FichT: '',
            EspT: '',
            IntCmp: '',
            OdC: '',
            EnMq: '',
            Etiq: '',
        })
    }

    async onSubmitPayrollSettings() {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        this.payrollSettings = this.savePayrollSettings();
        
        await this.service.putPayrollSettings(this.payrollSettings, '1');
        await this.fsService.update(`${Globals.CATALOGS_SETTINGS}/folios`, {
          customerBill: this.payrollSettings.folios.customerBill,
          income: this.payrollSettings.folios.income,
        });
        this.router.navigate(['/']);
    }

    savePayrollSettings() {
        console.log(this.payrollSettingsForm.get('tableQuantity').value)
        const payrollSettingsJson: any = this.payrollSettingsForm.touched ? {
            activitiesCapture: this.payrollSettingsForm.get('activitiesCapture').value,
            finalDay: this.weekdays.find(x => x.id$ === this.payrollSettingsForm.get('startDay').value).prev,
            paymentPeriod: this.payrollSettingsForm.get('paymentPeriod').value,
            startDay: this.payrollSettingsForm.get('startDay').value,
            tableQuantity: +this.payrollSettingsForm.get('tableQuantity').value,
            updatedAt: new Date(),
            multiplicationFactor: this.payrollSettingsForm.get('multiplicationFactor').value,
            paymentPerPerson: this.payrollSettingsForm.get('paymentPerPerson').value,
            paymentPerPersonF: this.payrollSettingsForm.get('paymentPerPersonF').value,
            cfCommission: this.payrollSettingsForm.get('cfCommission').value,
            maxDaysLoad: this.payrollSettingsForm.get('maxDaysLoad').value,
            entryTime: this.payrollSettingsForm.get('entryTime').value,
            businessDays: [
                !!this.payrollSettingsForm.get('businessDaySunday').value,
                !!this.payrollSettingsForm.get('businessDayMonday').value,
                !!this.payrollSettingsForm.get('businessDayTuesday').value,
                !!this.payrollSettingsForm.get('businessDayWednesday').value,
                !!this.payrollSettingsForm.get('businessDayThursday').value,
                !!this.payrollSettingsForm.get('businessDayFriday').value,
                !!this.payrollSettingsForm.get('businessDaySaturday').value
            ],
            bonus: this.payrollSettingsForm.get('bonus').value
        } : {
            tableQuantity: +this.payrollSettingsForm.get('tableQuantity').value,
            paymentPeriod: this.payrollSettingsForm.get('paymentPeriod').value,
            startDay: this.payrollSettingsForm.get('startDay').value,
        };
        if(this.foliosForm.touched) payrollSettingsJson.folios = this.foliosForm.value;
        if(this.defaultsForm.touched) payrollSettingsJson.defaults = this.defaultsForm.value;
        payrollSettingsJson.isoDescriptions = this.isoDescriptionsForm.value;
        payrollSettingsJson.specialRoles = this.specialRoles;

        return payrollSettingsJson;
    }

    changePaymentPeriod(paymentPeriodValue) {
        this.paymentPeriodModelChange.emit(paymentPeriodValue);

        if (paymentPeriodValue !== 'weekly') {
            this.weekdaysInit = 'monday';
        }
    }

    changeWeekdays(weekdaysValue) {
        this.weekdaysModelChange.emit(weekdaysValue);

        this.finalDayText = this.weekdays.find(x => x.id$ === weekdaysValue).prevName;
    }

    changeTab(tabNumber: number){
        this.tab = tabNumber;
    }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.r_data = this.rowsRead[index];
    
    this.r_config = this.r_configs[index];
  
    this.r_onChangeTable(this.r_config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    this.continue();
  }
  continue(){
    this.closeModalRead();
  }

  selectedIds: string [] = [];
  employees: any = {};
  get specialRoles(): SpecialRoles {
    return {
        qualityInspector: this.selectedIds[0]
    }
  }
  get readValid(){ return true; };
  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [//employee
        { title: 'Nombre', name: 'name' },
        { title: 'Folio', name: 'internalKey', sort: 'asc' },
        { title: 'Correo electrónico', name: 'email' },
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

  r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.r_config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
